import styled from 'styled-components'

import { AppFull } from '../../../../AppStyle';

const EditModeContent = styled(AppFull)`
  overflow: auto;
`

export {EditModeContent}
